import styled from 'styled-components';

export const HotTopicWrap = styled.div`
    width: 100%;
`;

export const HotTopicDetail = styled.div`
    width: 100%;
    img{
        width: 100%;
        border-radius: 20px;
        display: block;
        min-width: 100%;
        margin-bottom: 15px;
        cursor: pointer;
    }
`;

export const HotTopicText = styled.p`
    color: #000000;
    font-size: 16px;
    font-family: 'Jost', sans-serif;
    font-weight: 500;
    line-height: 26px;
    cursor: pointer;
`;
